import React, { useState, useEffect } from 'react'
import { Panel, Row } from 'rsuite'
import ClosureDurableArticlesTable from './ClosureDurableArticlesTable'
import ClosureDurableArticlesSearchForm from './ClosureDurableArticlesSearchForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../../constants/pathname'
import { doneLoading, startLoading } from '../../../utils/loading'
import { searchAssetClosure } from '../../../redux/actions/accountingAssetClosure'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'

export default function ClosureDurableArticlesWidget(props) {
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState(props.schema.result)
  const [isViewMode, setIsViewMode] = useState(props.isViewMode)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  const projectCode = sessionGetItemStr('projectCode')

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchAssetClosure(request, projectCode, pagenumber, pagesize)
      // console.log('searchAssetClosure ', response.model)
      setDataTable(response.model)
      // setDataTable()
      // var _schema = cloneDeep(formSchema)

      // _schema.result = response

      // setFormSchema(_schema)
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
  }

  const onSelect = (request) => {
    sessionSetItemStr('assetClosureId', request.id)
    sessionSetItemStr('assetClosureStep', 0)

    history.push({
      pathname: `${pathname.durableArticles.ManageDurableArticles}`,
    })
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={'รายการคำขอปิดครุภัณฑ์'} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {formSchema?.searchForm && (
          <div style={{ marginTop: 20 }}>
            <ClosureDurableArticlesSearchForm
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        {!isViewMode && (
          <Row style={{ marginTop: 20, marginRight: 10, textAlign: 'right' }}>
            <SaveButton
              icon="plus-square"
              style={{ marginBottom: -10 }}
              onClick={() => {
                sessionSetItemStr('assetClosureStep', 0)
                history.push({
                  pathname: `${pathname.durableArticles.ManageDurableArticles}`,
                })
              }}
            >
              สร้างคำขอปิดครุภัณฑ์
            </SaveButton>
          </Row>
        )}

        <ClosureDurableArticlesTable
          schema={dataTable}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
          isViewMode={isViewMode}
          onSelect={onSelect}
        />
      </Panel>
    </>
  )
}
